import React from 'react';
import { Link } from "react-router-dom";
import "./HomePage.css";
import MultiImageSlider from "../components/MultiImageSlider"; // Adjust the import path as needed
import DrinkCarousel from '../components/DrinkCarousel';

const HomePage = () => {
  return (
    <div className="home-container">

      {/* Hero Section */}
      <section className="home" id="home">
        <div className="row">
          <div className="content">
            <h3>L’expérience du coffee shop en Self-Service</h3>
            <Link to="/menu" className="btn">Découvrir notre menu</Link>
          </div>

          <div className="image">
            <img src="/images/cup.webp" className="main-home-image" alt="Café Adaroza" fetchpriority="high"></img>
          </div>
        </div>
      </section>

      {/* Welcome Section */}
      <section className="welcome-section">
        <h2>Adaroza, c’est votre adresse pour un café d’exception, de délicieuses pâtisseries et une expérience chaleureuse et accueillante.</h2>
      </section>

      {/* features(about) Section */}
      <section className="about" id="about">
        <h1 className="heading">À propos de nous<span>À propos de nous</span></h1>

        <div className="row">
          <div className="image">
            <img src="/images/about-img.webp" alt="Intérieur du coffee shop Adaroza" loading="lazy" decoding="async"></img>
          </div>

          <div className="content">
            <h3 className="title">Soyez les bienvenus!</h3>
            <p> Entrez chez Adaroza et découvrez une atmosphère chaleureuse et conviviale, où chaque détail est pensé pour votre confort.
              De notre décoration aux tons naturels à la douce lumière ambiante, Adaroza est bien plus qu’un simple coffee shop :
              c’est un lieu où l’on se détend, où l’on se retrouve et où l’on savoure chaque instant.</p>
            <h3>Notre menu propose une variété de délices artisanaux</h3>
            <div className="icons-container">
              <div className="icons">
                <h3>Cafés de spécialité</h3>
                <p>Du classique espresso au cappuccino onctueux, sans oublier les Frappuccinos rafraîchissants.</p>
              </div>
              <div className="icons">
                <h3>Pâtisseries gourmandes</h3>
                <p>Des douceurs fraîchement préparées, parfaites pour accompagner votre café.</p>
              </div>
              <div className="icons">
                <h3>Light Bites</h3>
                <p>Une sélection de sandwichs, croissants, crêpes et bien plus encore pour un repas rapide et savoureux.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Multi Image Slider Section */}
      <section className="multi-image-slider-section">
        <MultiImageSlider />
      </section>

      {/* Experience Section */}
      <section className="experience">
        <h3>Une nouvelle expérience</h3>
        <p>
           <b>Plongez dans l’art du café</b> ☕✨
          Un nouveau coffee shop chaleureux où chaque tasse est préparée avec passion et savoir-faire.
          Rejoignez-nous bientôt pour savourer un café d’exception dans une ambiance unique.
        </p>
      </section>

      {/* carousel Section */}
      <section>
        <DrinkCarousel />
      </section>

      {/* Contact Section */}
      <section className="contact">
        <img src="/images/Logo Adaroza A.webp" alt="Adaroza Logo" />
        <p><b>Adresse:</b> Rue Ghar El Mehl 7, Lac 1</p>
        <p><b>Horaires:</b></p>
        <p>Lundi – Vendredi, 6:30 → 20:00</p>
        <p>Samedi – Dimanche, 8:00 → 20:00</p>
        <div className="social-media">
          <a href="https://www.facebook.com/profile.php?id=61565563451949" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/facebook-icon.webp" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/adaroza_cafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/Insta-icon.webp" alt="Instagram" />
          </a>
          <a href="https://www.tiktok.com/@adaroza_cafe" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="/images/tiktok icon.webp" alt="Tiktok" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
